export default "__VITE_PUBLIC_ASSET__4fa49445__"